<template>
    <div id="wrapper">
        <div id="content-wrapper" class="d-flex flex-column">
            <!-- Main Content -->
            <div id="content">
                <!-- Topbar -->
                <TopNavbar></TopNavbar>
                <!-- End of Topbar -->
                <!-- Begin Page Content -->
                 <slot />
                <!-- /.container-fluid -->
            </div>
            <!-- End of Main Content -->
            <!-- Footer -->
            <Footer></Footer>
            <!-- End of Footer -->
        </div>
    </div>
</template>

<script>
    import TopNavbar from "./partial/Navbar"
    import Footer from "./partial/Footer"
    export default {
        name: 'LayoutOperatorDashboard',
        components: {
            TopNavbar,
            Footer
        }
    }
</script>

<style>

</style>